export default "__VITE_ASSET__DLnUKVLn__"